"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _TextWithSyllabification = _interopRequireDefault(require("../../SIA-WEBSITE/TextWithSyllabification/TextWithSyllabification"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.masterarbeitBox-container {\n  padding-top: 0px;\n  width: 100%;\n  box-sizing: content-box;\n  height: 100%;\n  position: relative; }\n  .masterarbeitBox-container h3 {\n    margin: 0px;\n    max-width: 90%; }\n  .masterarbeitBox-container .subtext {\n    letter-spacing: 0.32px; }\n  .masterarbeitBox-container .link {\n    cursor: pointer;\n    width: fit-content;\n    object-fit: contain; }\n  .masterarbeitBox-container .media {\n    width: 100%;\n    aspect-ratio: 1.7 !important; }\n  .masterarbeitBox-container .rank {\n    background-color: #fff;\n    color: #000000;\n    border-radius: 12px;\n    padding: 4px 8px 0px 8px;\n    border: 1px solid #000000;\n    width: fit-content;\n    height: 24px; }\n  .masterarbeitBox-container .rank-image {\n    position: absolute;\n    top: 8px;\n    left: 8px; }\n";
  const fileName = "MasterarbeitBox_MasterarbeitBox";
  const element = document.querySelector("style[data-sass-component='MasterarbeitBox_MasterarbeitBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MAX_DESCRIPTION = 225;
const MasterarbeitBox = _ref => {
  let {
    title,
    author,
    lang,
    pictures_gallery,
    rank,
    school,
    lead,
    id,
    year
  } = _ref;
  const isLongDescription = lead?.length > MAX_DESCRIPTION;
  const description = `${lead?.length > 0 ? lead?.slice(0, MAX_DESCRIPTION)?.trim() : ''}${isLongDescription ? '...' : ''}`;
  const media = pictures_gallery?.map(picture => {
    return {
      src: picture.tablet?.url,
      type: 'IMAGE'
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `masterarbeitBox-container sia-margin-02-bottom`
  }, media?.length > 0 && /*#__PURE__*/_react.default.createElement("img", {
    className: "media",
    src: media[0].src
  }), rank?.name && /*#__PURE__*/_react.default.createElement("div", {
    className: `sia-text-06 rank ${media?.length > 0 ? 'rank-image' : 'rank-no-image'}`
  }, /*#__PURE__*/_react.default.createElement("span", null, rank.name)), school?.name && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-01 sia-margin-02-top"
  }, school.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-margin-01-top sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-10 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-06 sia-margin-02-top"
  }, year), /*#__PURE__*/_react.default.createElement("p", {
    className: "subtext sia-text-06 sia-margin-03-top sia-margin-03-bottom"
  }, author ? `${author} | ` : ``), id && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "link",
    to: `/${lang}/cms/${id}`
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "page-action-down-32"
  })));
};
MasterarbeitBox.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    src: _propTypes.default.string.isRequired,
    srcTablet: _propTypes.default.string,
    srcMobile: _propTypes.default.string,
    type: _propTypes.default.string.isRequired,
    imagePlaceholder: _propTypes.default.string,
    copyright: _propTypes.default.object
  })),
  article_lead: _propTypes.default.string,
  title: _propTypes.default.string,
  page_lead: _propTypes.default.string,
  path: _propTypes.default.string,
  history: _propTypes.default.object,
  lang: _propTypes.default.string
};
MasterarbeitBox.defaultProps = {};
var _default = exports.default = MasterarbeitBox;